import React, { createContext, useEffect, useState, useContext } from 'react'
import PropTypes from 'prop-types'

export const themes = {
  light: {
    '--primary': '#1A1D30',
    '--primary-invert': '#ffffff',
    '--primary-info': '#1d317d',
    '--primary-grey': '#666666',
    '--primary-container': '#ffffff',
    '--primary-container-dark': '#1A1D30',
    '--primary-container-grey': '#e8eaf2',
    '--border-ucc-button': '#138496',
    
    '--secondary': '#555',
    '--secondary-container': '#1A1D30',
    

    '--terciary-container': '#f8f9fa',
    
    '--nav-container': '#1A1D30',
    '--nav-primary': '#cecece',
    '--nav-active': '#e7e7e7',
    '--nav-menu': '#fff',
    '--nav-bar-hover': '#6c757d40',
    
    '--form-field-background': '#0e192a',
    
    '--body-title': '#1A1D30',
    
    '--course-container': '#f8f9fa',
    
    '--cards-container': '#ffffff',
    '--cards-container-secondary': '#f7f7f7',
  },
  dark: {
    '--primary': '#ffffff',
    '--primary-invert': '#1A1D30',
    '--primary-info': '#0063aa',
    '--primary-grey': '#ffffff',
    '--primary-container': '#292929',
    '--primary-container-dark': '#ffffff14',
    '--primary-container-grey': '#6b6b6b',
    '--border-ucc-button': '#ffffff',
    
    '--secondary': '#ffffff',
    '--secondary-container': '#191919',
    '--terciary-container': '#191919',
    
    '--nav-container': '#383838',
    '--nav-primary': '#cecece',
    '--nav-active': '#e7e7e7',
    '--nav-menu': 'rgba(255, 255, 255, 0.95)',
    '--nav-bar-hover': '#6c757d40',

    '--form-field-background': '#292929',

    '--body-title': '#ffffff',

    '--course-container': '#292929',

    '--cards-container': '#373737',
    '--cards-container-secondary': '#ffffff14',
  }
}

const ThemeContext = createContext(null)

export const useTheme = () => useContext(ThemeContext)

const DEFAULT_THEME = 'light'

const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(DEFAULT_THEME);
  
  // Inicializa el tema basado en localStorage o en el tema del dispositivo
  useEffect(() => {
    const localTheme = typeof window !== 'undefined' ? localStorage.getItem('theme') : undefined
    const deviceTheme = getDeviseTheme()
    setTheme(localTheme || deviceTheme || DEFAULT_THEME)
  }, [])

  // Guarda el estado del Tema en localStorage
  useEffect(() => {
    if (theme) {
      localStorage.setItem('theme', theme)
    }
  }, [theme])

  // Cambiando de Tema con el boton del sitio
  const toggleTheme = () => {
    setTheme((prevTheme) => (prevTheme === 'light' ? 'dark' : 'light'))
  }

  // Cambio a "light" al recargar el sitio
  if (typeof window !== 'undefined') {
    (window.onbeforeunload = function () {
      localStorage.setItem('theme', 'light')
    })
  }

  return (
    <ThemeContext.Provider value={{ theme, setTheme, toggleTheme }}>
      <div style={{ ...themes[theme], background: 'var(--primary-container)' }}>
        {children}
      </div>
    </ThemeContext.Provider>
  )
}

const getDeviseTheme = () => {
  if (typeof window !== 'undefined') {
    if (window.matchMedia) {
      if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
        return 'dark'
      } else {
        return 'light'
      }
    } else {
      return DEFAULT_THEME
    }
  } else {
    return undefined
  }
}

ThemeProvider.propTypes = {
  children: PropTypes.array
}

export default ThemeProvider